
import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import config from '../../../src/globs/config'
import LoadingState from '../../components/common/loading-state';
import gaPush from '../../globs/utils/google-analytics';

// let timeout = null;

class CustomerList extends React.Component {

  constructor(props) {
    super(props);
    const pageNo = props.pageNo;
    // const onSearchCustomerList = props.customer && props.customer.customerList;
    this.state = {
      customerSearchInput: '',
      hasFinishedLoadingData: false,
      showLoader: false,
      pageNo,
      loadMoreShow: true,
      noDataForDuration: false,
      onSearchCustomerList: '',
      customerCountStatus: true,
      shouldShowLoadMore: true,
    };
  }
  static propTypes = {
    dataLoad: PropTypes.func,
    onSearchClearCustomerList: PropTypes.func,
  }
  static defaultProps = {
    dataLoad: undefined,
    onSearchClearCustomerList: undefined,
  }
  componentDidMount() {
    this.fireGaEventPagePath(window.location.pathname + window.location.search);
    const { props } = this;
    // this.props.onSearchClearCustomerList({
    //   key: 'onSearchClearCustomerList'
    // });
    this.setState({
      showLoader: true,
      // typeValue: 'startLoad',
    });
    const salesOfficerId = props.user.id;
    const url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/customer_count`;
    props.dataLoad({
      key: 'customersCount',
      url: url
    });
    if (this.props.customerListing.length < 1) {
      this.getCustomerList();
      // this.setState({
      //   showLoader: true,
      // });
    }

    // if (this.props.customerList.length === this.props.customerCount.count) {
    //   this.setState({
    //     noDataForDuration: false,
    //     loadMoreShow: false,
    //   });
    // }
    // if (props.customerList.length < 1) {
    //   this.setState({
    //       noDataForDuration: true,
    //   });
    //   setTimeout(() => {
    //       this.setState({
    //           noDataForDuration: false,
    //       });
    //   }, 5000);
    // }
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log('prevProps >>>', prevProps);
    const { props } = this;
    // Only update when API status changes from PENDING to complete
    // Add guards to prevent infinite loops in React 19
    if ((prevProps.ajaxStatuses.customers === 'PENDING' &&
      props.ajaxStatuses.customers === '') || (prevProps.ajaxStatuses.onSearchCustomers === 'PENDING' &&
        props.ajaxStatuses.onSearchCustomers === '') || (prevProps.ajaxStatuses.customersCount === 'PENDING' &&
          props.ajaxStatuses.customersCount === '')) {
      const noMoreData = props.customerListing.length === prevProps.customerListing.length;
      // console.log('noMoreData', noMoreData);

      // Only update shouldShowLoadMore if it actually needs to change
      const shouldShowLoadMore = this.props.customerListing.length !== this.props.customerCount.count;
      if (this.state.shouldShowLoadMore !== shouldShowLoadMore) {
        this.setState({
          shouldShowLoadMore: shouldShowLoadMore,
        });
      }

      this.checkLengthofResponse();

      // Only update if showLoader or noDataForDuration need to change
      const newNoDataForDuration = noMoreData && this.props.customer && this.props.customer.customerList && this.props.customer.customerList.length === 0;
      if (this.state.showLoader !== false || (noMoreData && this.state.noDataForDuration !== newNoDataForDuration)) {
        if (noMoreData) {
          this.setState({
            showLoader: false,
            noDataForDuration: newNoDataForDuration,
          });
          setTimeout(() => {
            this.setState({
              noDataForDuration: false,
            });
          }, 5000);
        } else {
          this.setState({
            showLoader: false,
            noDataForDuration: false,
          });
        }
      }
    }
  }

  fireGaEventPagePath = (path) => {
    gaPush('pageview', {
      path,
    });
  };

  fireGaEvent = (act, action, label) => {
    gaPush('event', {
      category: act,
      action,
      label,
    });
  };

  checkLengthofResponse = () => {

    const customerAfterSearchListLength = this.props.customer && this.props.customer.customerList && this.props.customer.customerList.length;
    const customerListLength = this.props.customerListing && this.props.customerListing.length;
    if ((customerAfterSearchListLength > 0 && customerAfterSearchListLength < 10) || (customerListLength > 0 && customerListLength < 10)) {
      this.setState({
        loadMoreShow: false,
      });
    } else {
      this.setState({
        loadMoreShow: true,
      });
    }
  }

  fetchMoreData = () => {
    // const { props } = this;
    // const salesOfficerId = props.user.id;
    // this.setState(prevState => {
    //   return {pageNo: prevState.pageNo + 1
    //   }
    gaPush('event', {
      category: 'CustomerList',
      action: 'LoadMoreClicked',
    });
    let prevState = this.props.pageNo;
    prevState++;
    this.setState({
      pageNo: prevState,
      loadMoreShow: false,
      showLoader: true,
    }, () => {
      if (this.state.customerSearchInput === '') {
        this.getCustomerList();
      } else {
        const { props } = this;
        const salesOfficerId = props.user.id;
        // console.log('this.state.pageNo', this.state.pageNo);
        const url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses?pageNo=${this.state.pageNo}&business_name=${this.state.customerSearchInput}`;
        props.dataLoad({
          key: 'onSearchCustomers',
          url: url
        });
      }

    });
    setTimeout(() => {
      this.setState({
        loadMoreShow: true,
        noDataForDuration: false,
      });
    }, 5000);
  }

  getCustomerList = () => {
    const { props } = this;
    const salesOfficerId = props.user.id;
    // console.log('this.state.pageNo', this.state.pageNo);
    const url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses?pageNo=${this.state.pageNo}`;
    props.dataLoad({
      key: 'customers',
      url: url
    });
  }

  orderPage = (cust) => {
    // console.log('customer id', id)
    // this.props.history.push(/home:${this.state.userID}
    this.fireGaEvent('CustomerList', 'CustomerClicked', `${cust.sap_code}`);
    // this.props.history.push(`customer-orders/${cust.id}/${cust.sap_code}/${cust.name}`);
    this.props.history.push(`customer-orders/${cust.id}`);


  }

  backPage = () => {
    this.props.history.push('home-page');
    this.props.onSearchClearCustomerList({
      key: 'onSearchClearCustomerList'
    });
  }

  onSearch = ({ target }) => {
    this.props.onSearchClearCustomerList({
      key: 'onSearchClearCustomerList'
    });
    const { value } = target;
    // console.log('value >>>', value);
    // clearTimeout(timeout);

    const { props } = this;
    const salesOfficerId = props.user.id;
    if (value !== '') {
      this.setState({
        customerSearchInput: value,
        pageNo: 1,
        loadMoreShow: false,
        customerCountStatus: false,
        // showLoader: true,
      }, () => {
        const url = `${config.apiContextPath}/sales_officers/${salesOfficerId}/businesses?pageNo=${this.state.pageNo}&business_name=${value}`;
        props.dataLoad({
          key: 'onSearchCustomers',
          url: url
        });
      });
    } else {
      // console.log('HOOOO');
      this.props.onSearchClearCustomerList({
        key: 'onSearchClearCustomerList'
      });
      setTimeout(() => this.getCustomerList(), 1000);
      this.setState({
        customerSearchInput: '',
        onSearchCustomerList: '',
        customerCountStatus: true,
        // loadMoreShow: true,
        // hasFinishedLoadingData: true,
        // hasMore: true,
        // customersList: this.state.tempCustomerList,
      });
    }
  }


  render() {
    const customerList = this.props.customerListing;
    const customerLength = customerList.length;
    const newCustomerListLength = this.props.customer && this.props.customer.customerList && this.props.customer.customerList.length;
    return (
      <div>
        <div className="lr-main-view__header">
          <button type="button" className="lr-main-view__header-title" onClick={this.backPage}>
            <span className="icon-back"></span><span>Customers</span>
          </button>
        </div>
        <div className="search-customer">
          <i className="icon-search" />
          <input type="text"
            placeholder="Find a Customer by number or name"
            value={this.state.customerSearchInput}
            onChange={this.onSearch}
            onFocus={this.onFindCustFocus}
          />
        </div>
        <div className="no-of-customer">
          <span>No of Customer : {this.state.customerSearchInput === '' ? customerLength : newCustomerListLength} {this.state.customerCountStatus && this.props.customerCount.count > 0 ? <span> of {this.props.customerCount.count}</span> : ''} </span>
        </div>
        {this.state.customerSearchInput === '' && customerList && customerList.map((cust) => {
          return <div key={cust.sap_code}>
            <div className="customer-list-container">
              <div className="customer-list" onClick={() => this.orderPage(cust)}>
                <i className="icon-customer" />
                <span>{cust.sap_code}</span>
                <span>{cust.name}</span>
                {
                  cust.last_seen_at ?
                    <React.Fragment><span>Last app visit: {cust.last_seen_at ? moment.parseZone(cust.last_seen_at).format('DD.MM.YYYY') : 'Not visited the app last 30 days'}</span> {
                      cust.last_app_order ? <span>Last app order: {moment.parseZone(cust.last_app_order).format('DD.MM.YYYY')}</span> : <span>Not ordered in app last 30 days</span>
                    }
                    </React.Fragment> :
                    <span>Not visited the app last 30 days</span>
                }

                {/* <span> Last Visit: {cust.last_seen_at}</span>
                        <span> Last app Order:{cust.last_app_order}</span> */}
                <i className="icon-arrow_right" />
              </div>
            </div>
          </div>
        })}
        {this.state.customerSearchInput && this.props.customer.customerList.map((cust) => {
          return <div>
            <div className="customer-list-container">
              <div className="customer-list" onClick={() => this.orderPage(cust)}>
                <i className="icon-customer" />
                <span>{cust.sap_code}</span>
                <span>{cust.name}</span>
                {
                  cust.last_seen_at ?
                    <React.Fragment><span>Last visit: {cust.last_seen_at ? moment.parseZone(cust.last_seen_at).format('DD.MM.YYYY') : 'Not visited the app last 30 days'}</span> {
                      cust.last_app_order ? <span>Last app order: {moment.parseZone(cust.last_app_order).format('DD.MM.YYYY')}</span> : <span>Not ordered in app last 30 days</span>
                    }
                    </React.Fragment> :
                    <span>Not visited the app last 30 days</span>
                }

                {/* <span> Last Visit: {cust.last_seen_at}</span>
                          <span> Last app Order:{cust.last_app_order}</span> */}
                <i className="icon-arrow_right" />
              </div>
            </div>
          </div>
        })}
        {
          this.state.shouldShowLoadMore && this.state.loadMoreShow &&
          <div className="loadmore">
            <button onClick={this.fetchMoreData}>load more</button>
          </div>
        }
        {!this.state.showLoader &&
          <div>
            {this.state.noDataForDuration &&
              <div className="response-information-toaster">
                <div className="noorders-toaster">
                  <span>No more customer found</span>
                </div>
              </div>
            }
          </div>
        }

        {
          this.state.showLoader &&
          <div>
            <LoadingState />
            <div className="loadingContainer" />
          </div>
        }
      </div>
    )
  }
}

export default CustomerList;